export function getUVDSerialNumber(robotId: string) {
  const regex =
    /^(.*)-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  return robotId.replace(regex, "$1");
}

export function getUVDOrgId(robotId: string) {
  return robotId.split("-").slice(1).join("-");
}
